<div class="quote-icon img relative -top-4 w-14 h-auto" />

<style>
  /* Quote icon styling */
  .quote-icon {
    height: 32px;
    width: 50px;
    background-color: white;
    left: 43%;
    background-image: url('/assets/images/quote-icon.webp');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 50%;
  }
</style>
